/* eslint-disable no-console */

function error(params) {
  if (process.env.NODE_ENV !== 'production') {
    console.error(params);
  }
}

function info(params) {
  if (process.env.NODE_ENV !== 'production') {
    console.info(params);
  }
}

const devLogger = {
  error,
  info
};

export { devLogger };
